import { ABCFile, ABCCatalog, ActiveLoaderContext, AVM2LoadLibrariesFlags, Natives, } from '@awayfl/avm2';
import { release, assert, PromiseWrapper } from '@awayfl/swf-loader';
import { SecurityDomain } from './SecurityDomain';
import { initLink } from './link';
import { TextField, SceneImage2D, Font, Sprite, MovieClip, MorphSprite, FrameScriptManager, } from '@awayjs/scene';
import { FlashSceneGraphFactory } from './factories/FlashSceneGraphFactory';
import { WaveAudio } from '@awayjs/core';
import { BitmapImage2D } from '@awayjs/stage';
import { Graphics } from '@awayjs/graphics';
var PlayerGlobal = /** @class */ (function () {
    function PlayerGlobal() {
    }
    Object.defineProperty(PlayerGlobal.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlayerGlobal.prototype, "content", {
        get: function () {
            return this._content;
        },
        enumerable: true,
        configurable: true
    });
    PlayerGlobal.prototype.createSecurityDomain = function (avmStage, swfFile, libraries) {
        var _this = this;
        this._avmStage = avmStage;
        if (this._avmStage.avmTestHandler) {
            Natives.print = function (sec, expression) {
                var _a, _b;
                var message = '';
                if (arguments.length == 2) {
                    message = (_a = arguments[1]) === null || _a === void 0 ? void 0 : _a.toString();
                }
                else {
                    for (var i = 1; i < arguments.length; i++) {
                        // eslint-disable-next-line prefer-rest-params
                        message += (_b = arguments[i]) === null || _b === void 0 ? void 0 : _b.toString();
                        if (i !== arguments.length - 1) {
                            message += ' ';
                        }
                    }
                }
                var messageSplit = message.split('\n');
                for (var i = 0; i < messageSplit.length; i++) {
                    console.log('%c Test-Trace from SWF:', 'color: DodgerBlue', messageSplit[i]);
                    avmStage.avmTestHandler.addMessage(messageSplit[i]);
                }
            };
        }
        initLink();
        var result = new PromiseWrapper();
        release || console.log('createSecurityDomain');
        release || assert(!!(libraries & AVM2LoadLibrariesFlags.Builtin));
        release || console.log('Load builtin.abc file');
        BrowserSystemResourcesLoadingService.getInstance()
            .load(PlayerGlobal.builtinsBaseUrl + "/builtin.abc", 'arraybuffer')
            .then(function (buffer) {
            var sec = new SecurityDomain();
            var env = { url: 'builtin.abc', app: sec.system };
            var builtinABC = new ABCFile(env, new Uint8Array(buffer));
            sec.swfVersion = swfFile.swfVersion;
            sec.system.loadABC(builtinABC);
            sec.initialize();
            sec.system.executeABC(builtinABC);
            sec.player = avmStage;
            //SWF.leaveTimeline();
            //// If library is shell.abc, then just go ahead and run it now since
            //// it's not worth doing it lazily given that it is so small.
            //if (!!(libraries & AVM2LoadLibrariesFlags.Shell)) {
            //  var shellABC = new Shumway.AVMX.ABCFile(new Uint8Array(buffer));
            //  sec.system.loadAndExecuteABC(shellABC);
            //  result.resolve(sec);
            //  SystemResourcesLoadingService.instance.load(SystemResourceId.ShellAbc).then(function (buffer) {
            //    var shellABC = new Shumway.AVMX.ABCFile(new Uint8Array(buffer));
            //    sec.system.loadAndExecuteABC(shellABC);
            //    result.resolve(sec);
            //  }, result.reject);
            //  return;
            //}
            if (libraries & AVM2LoadLibrariesFlags.Playerglobal) {
                return Promise.all([
                    BrowserSystemResourcesLoadingService.getInstance().load(PlayerGlobal.builtinsBaseUrl + "/playerglobal.abcs", 'arraybuffer'),
                    BrowserSystemResourcesLoadingService.getInstance().load(PlayerGlobal.builtinsBaseUrl + "/playerglobal.json", 'json'),
                ]).then(function (results) {
                    release || console.log('Load playerglobal.abcs & playerglobal.json');
                    var catalog = new ABCCatalog(sec.system, new Uint8Array(results[0]), results[1]);
                    release || console.log('add playerglobals as ABCCatalog');
                    sec.addCatalog(catalog);
                    BrowserSystemResourcesLoadingService.getInstance()
                        .load(PlayerGlobal.builtinsBaseUrl + "/avmplus.abc", 'arraybuffer')
                        .then(function (buffer) {
                        //var sec = new AXSecurityDomain();
                        var env = { url: 'avmplus.File', app: sec.system };
                        var avmPlusABC = new ABCFile(env, new Uint8Array(buffer));
                        sec.system.loadABC(avmPlusABC);
                        //sec.initialize();
                        sec.system.executeABC(avmPlusABC);
                    }, result.reject)
                        .then(function () {
                        _this._contentLoaderInfo = new sec.flash.display.LoaderInfo(_this, _this._avmStage.root);
                        _this._contentLoaderInfo.url = swfFile.url;
                        _this._applicationDomain = new sec.flash.system.ApplicationDomain();
                        var loaderContext = new sec.flash.system.LoaderContext(false, _this._applicationDomain);
                        ActiveLoaderContext.loaderContext = loaderContext;
                        _this._stage = new sec.flash.display.Stage();
                        sec.flash.display.DisplayObject.axClass._activeStage = _this._stage;
                        _this._avmStage.root.adapter = _this._stage;
                        _this._stage.adaptee = _this._avmStage.root;
                        result.resolve(new FlashSceneGraphFactory(sec));
                    }, result.reject);
                }, result.reject);
            }
            // todo: is this needed:
            result.resolve(null);
        }, result.reject);
        return result.promise;
    };
    PlayerGlobal.prototype.enterFrame = function () {
        this._stage && this._stage.enterFrame();
    };
    PlayerGlobal.prototype.resizeStage = function () {
        // it can happen that resizeStage is called before createSecurityDomain has finished and stage exists
        this._stage && this._stage.resizeCallback();
    };
    PlayerGlobal.prototype.addAsset = function (asset, addScene) {
        asset.adapter.loaderInfo = this._contentLoaderInfo;
        switch (asset.assetType) {
            case TextField.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
            }
            case SceneImage2D.assetType:
            case BitmapImage2D.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
                // we should only do this for bitmaps loaded from jpg or png
                // todo:
                //if (this._isImage)
                //	(<AwayDisplayObjectContainer> this._adaptee).addChild(
                //	new Bitmap(<BitmapData> (<SceneImage2D> asset).adapter).adaptee);
            }
            case WaveAudio.assetType: {
                this._applicationDomain.addAudioDefinition(asset.name, asset);
                break;
            }
            case Font.assetType: {
                this._applicationDomain.addFontDefinition(asset.name, asset);
                break;
            }
            case Sprite.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
            }
            case MovieClip.assetType: {
                this._applicationDomain.addDefinition(asset.name, asset);
                // if this is the "Scene 1", we make it a child of the loader
                if (addScene && asset.isAVMScene) {
                    // "Scene 1" when AWDParser, isAVMScene when using SWFParser
                    this._content = asset.adapter.clone();
                    this._content.loaderInfo = this._contentLoaderInfo;
                    this._content.adaptee.reset();
                    this._content.adaptee.firstFrameOnSWFStart = true;
                    FrameScriptManager.invalidAS3Constructors = true;
                    this._stage.adaptee.addChild(this._content.adaptee);
                    FrameScriptManager.execute_as3_constructors_recursiv(this._content.adaptee);
                    this._content.dispatchStaticEvent('added', this._content);
                    this._content.dispatch_ADDED_TO_STAGE(true);
                }
                break;
            }
            case '[asset Generic]': {
                this._applicationDomain.addDefinition(asset.name, asset);
                break;
            }
            case Graphics.assetType:
            case MorphSprite.assetType: {
                break;
            }
            default: {
                console.warn('Loaded unhandled asset-type', asset.assetType);
            }
        }
    };
    PlayerGlobal.builtinsBaseUrl = './assets/builtins/';
    return PlayerGlobal;
}());
export { PlayerGlobal };
var BrowserSystemResourcesLoadingService = /** @class */ (function () {
    function BrowserSystemResourcesLoadingService() {
    }
    BrowserSystemResourcesLoadingService.getInstance = function () {
        if (BrowserSystemResourcesLoadingService._instance)
            return BrowserSystemResourcesLoadingService._instance;
        return (BrowserSystemResourcesLoadingService._instance = new BrowserSystemResourcesLoadingService());
    };
    BrowserSystemResourcesLoadingService.prototype.load = function (url, type) {
        return this._promiseFile(url, type);
    };
    BrowserSystemResourcesLoadingService.prototype._promiseFile = function (path, responseType) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', path);
            xhr.responseType = responseType;
            xhr.onload = function () {
                var response = xhr.response;
                if (response) {
                    if (responseType === 'json' && xhr.responseType !== 'json') {
                        response = JSON.parse(response);
                    }
                    resolve(response);
                }
                else {
                    reject('Unable to load ' + path + ': ' + xhr.statusText);
                }
            };
            xhr.onerror = function () {
                reject('Unable to load: xhr error');
            };
            xhr.send();
        });
    };
    return BrowserSystemResourcesLoadingService;
}());
